<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('account.notification.user')}} </b-th>
            <b-th> {{$t('account.notification.signalCode')}} </b-th>
            <b-th> {{$t('account.notification.signal')}} </b-th>
            <b-th> {{$t('account.notification.module')}} </b-th>
            <b-th> {{$t('account.notification.send')}} </b-th>
            <b-th>{{$t('account.notification.operations')}}</b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="not in notifications" :key="not.id">
                <b-td> {{not.account_user_info.name}} </b-td>
                <b-td> {{not.signal_group_def.name}} </b-td>
                <b-td> {{not.signal_group_def.code}} </b-td>
                <b-td> {{not.sys_module_info.name}} </b-td>
                <b-td> 
                    <b-icon v-if="not.is_send" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.active')"></b-icon>
                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.active')"></b-icon>
                </b-td>
                <b-td> 
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true"  @click="openModal('edit', not)"  ></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('delete', not)"></b-icon>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    export default {
        name: "NotificationForm",
        data : () => {
            return {
            }
        },
         props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            openModal:function(name, data){
                this.modalType(true, 'Notification',5)
                this.modalEvent(true, name, data)
            },
             
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            notifications(){
                return this.$store.getters.getAccountNotifications
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/zone.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/NotificationForm.vue